module.exports = __webpack_public_path__ + "account/assets/telegram.315140eb.svg";